import {
  ActionType,
  DownloadBusinessUserCSVResponse,
} from "models/userListBusiness/downloadBusinessUserCSV";

export const downloadBusinessUserCSVAction = () => {
  return {
    type: ActionType.DOWNLOAD_BUSINESS_USER_CSV,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DOWNLOAD_BUSINESS_USER_CSV_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: DownloadBusinessUserCSVResponse
) => {
  return {
    type: ActionType.DOWNLOAD_BUSINESS_USER_CSV_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.DOWNLOAD_BUSINESS_USER_CSV_RESET_DATA,
  };
};
